import { Button } from "@/src/components/ui/button";
import { useState } from "react";
import { RevertBookingModal } from "./RevertBookingModal";

const RevertBookingToOffer = ({ bookingId }: { bookingId: string }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="flex justify-end gap-x-4 w-full">
      <Button onClick={() => setOpen(true)} variant="destructive">
        Revert to Offer
      </Button>
      {open && <RevertBookingModal open={open} setOpen={setOpen} bookingId={bookingId} />}
    </div>
  );
};

export default RevertBookingToOffer;
